import { APP_CONFIG } from '@core/configs';

export const API_BASE_URL = APP_CONFIG.apiBaseUrl;
export const TOKEN_URL = APP_CONFIG.tokenUrl;

export const API_ENDPOINT = {
  token: {
    loginStaff: TOKEN_URL + '/token/staff-auth-sso',
    loginAdmin: TOKEN_URL + '/token/admin-auth-sso',
    loginStaffModule: TOKEN_URL + '/token/staff-auth',
    loginMasterModule: TOKEN_URL + '/token/master-auth',
    loginAdminModule: TOKEN_URL + '/token/admin-auth',
    refreshToken: TOKEN_URL + '/ck-pass/token/refresh',
    logout: TOKEN_URL + '/token/logout',
    logoutGlobal: TOKEN_URL + '/token/logout-global',
    staffNewToken: TOKEN_URL + '/token/sso/staff/new-token',
    adminNewToken: TOKEN_URL + '/token/sso/admin/new-token',
  },
  auth: {
    base: TOKEN_URL + '/user',
    loginByCKPass: API_BASE_URL + 'login',
    verifyRefreshToken: TOKEN_URL + '/ck-pass/token/verify-refresh-token',
  },
  help: {
    controller: APP_CONFIG.apiBaseUrl + 'help/',
    getAll: 'get-all/',
    getDetail: 'get-detail/',
    createDraft: 'create-draft',
  },
  template: {
    controller: APP_CONFIG.apiBaseUrl + 'template/',
    getAll: 'get-all/',
    getDetail: 'get-detail/',
  },
  organization: {
    controller: APP_CONFIG.apiBaseUrl + 'organization/',
    getAll: 'get-all/',
    isLastOrganizationInCust: 'isLastOrganizationInCust',
    deleteOrganization: 'deleteOrganization',
    updateCompanyOfOrg:'updateCompanyOfOrg',
    dropTablesOfSchema : 'dropTablesOfSchema',
    getAllTableOfSchema: 'getAllTableOfSchema',
    exportTablesToS3:'exportTablesToS3',
    deleteOrganizationWithoutDropSchema: 'deleteOrganizationWithoutDropSchema'
  },
  user: {
    controller: APP_CONFIG.apiBaseUrl + 'user/',
    checkUserByEMail: 'check-user-by-email',
    getSupportStaffsByCustId: 'get-support-staffs',
    inviteSupportStaff: 'invite-support-staff',
    deleteSupportStaff: 'delete-support-staff'
  },
  resourcepolicy: {
    checkResourcePolicy: APP_CONFIG.apiBaseUrl + 'resourcepolicy/check-resource-policy'
  }

};
